import { CompanyRole } from '../company_role_assignment';
import { StockLocationRole } from '../stock_location_role_assignment';

export class OrderFlowPermission {
  companyRole?: CompanyRole;
  stockLocationRole?: StockLocationRole = StockLocationRole.STOCK_LOCATION_SUPERVISOR;

  assigned: boolean = false;
  creator: boolean = false;
}
